export const homeTranslation = {
  title: 'home.title',
  subtitle: 'home.subtitle',
  subtitleMaster: 'home.subtitleMaster',
  subtitleNurseryVisor: 'home.subtitleNurseryVisor',
  subtitleNurseryAdmin: 'home.subtitleNurseryAdmin',
  secondSubtitleMaster: 'home.secondSubtitleMaster',
  invoices: {
    table: {
      title: 'home.invoices.table.title',
      viewMore: 'home.invoices.table.view_more',
    },
  },
  transactions: {
    table: {
      title: 'home.transactions.table.title',
      viewMore: 'home.transactions.table.view_more',
    },
  },
  module: {
    sticker: {
      title: 'home.module.sticker.title',
      description: 'home.module.sticker.description',
      button: 'home.module.sticker.button',
    },
  },
  advertisementSpace: {
    modules: {
      module1: {
        title: 'home.advertisement_space.module1.title',
        description: 'home.advertisement_space.module1.description',
        image: 'home.advertisement_space.module1.image',
        link: 'home.advertisement_space.module1.link',
        openLinkNewTab: 'home.advertisement_space.module1.openLinkNewTab',
        cta: 'home.advertisement_space.module1.cta',
      },
      module1Premium: {
        title: 'home.advertisement_space.module1Premium.title',
        description: 'home.advertisement_space.module1Premium.description',
        image: 'home.advertisement_space.module1Premium.image',
        link: 'home.advertisement_space.module1Premium.link',
        cta: 'home.advertisement_space.module1Premium.cta',
      },
      module2: {
        title: 'home.advertisement_space.module2.title',
        description: 'home.advertisement_space.module2.description',
        image: 'home.advertisement_space.module2.image',
        link: 'home.advertisement_space.module2.link',
        openLinkNewTab: 'home.advertisement_space.module2.openLinkNewTab',
        cta: 'home.advertisement_space.module2.cta',
      },
      module3: {
        title: 'home.advertisement_space.module3.title',
        description: 'home.advertisement_space.module3.description',
        image: 'home.advertisement_space.module3.image',
        link: 'home.advertisement_space.module3.link',
        openLinkNewTab: 'home.advertisement_space.module3.openLinkNewTab',
        cta: 'home.advertisement_space.module3.cta',
      },
    },
  },
}
